export default "__VITE_ASSET__$wT2RjN1__"